export enum AssociatedAccountPriority {
    Primary = 'P',
    NonPrimary = 'NP',
}
